export default __webpack_public_path__ + "static/N0069-6b4435df38399f6534eb702cffa11d9e.png";